import { db } from "./firestoreService";
import { COLLECTION_PARTNER } from "./firebaseConstants";

export function listenToPartnerFromFirestore(id: string) {
  return db.collection(COLLECTION_PARTNER).doc(id);
}
